export function compareString(stringA, stringB) {
    const STRING_A = stringA;
    const STRING_B = stringB;

    if (STRING_A > STRING_B)
        return 1;
    if (STRING_A < STRING_B)
        return -1;
    return 0;
}